// src/lib/organizerAccess.js
//
// Single source of truth for "does this organizer have real, full access"
// on the frontend -- mirrors the backend's _resolveOrganizer gate in
// src/middleware.js:
//   1. organizer_status === 'active'   (platform admin approval)
//   2. tos_accepted                    (Terms/Privacy accepted)
//   3. license_paid OR plan_id === 'eval'
//      (paid license fee, OR the free eval tier waiver -- eval organizers
//      get real, capped access without payment; see entitlements.js on
//      the backend for the actual pool/participant caps)
//
// This used to be inlined as `user.organizer_status === 'active' &&
// user.tos_accepted && user.license_paid` in three separate places
// (App.js's 'admin' tab, App.js's 'become-organizer' tab, and Navbar.js's
// status badge) -- all three missed the eval waiver when it was added,
// which is exactly the kind of drift a single shared helper prevents.

export function hasOrganizerAccess(user) {
    if (!user) return false;
    return (
        user.organizer_status === 'active' &&
        user.tos_accepted &&
        (user.license_paid || user.plan_id === 'eval')
    );
}
